// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTASection_ctaSection__9eYjh","ctaTitle":"CTASection_ctaTitle__lTuym","ctaDescription":"CTASection_ctaDescription__WD6xS","ctaButton":"CTASection_ctaButton__5yrn6"};